import {BaseTileProvider} from './base-tile-provider';
import {sprintf} from 'sprintf-js';
import {MapProvider} from '../../enums/map-provider.enum';
import {MapType} from '../../enums/map-type';
import {SettingsService} from '../../services/settings.service';

export class OpenStreetMapsTileProvider extends BaseTileProvider {

  private static URL_OSM_STANDARD = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'; // servers: [abc].tile...

  getMapProvider(): string {
    return MapProvider.OSM_STANDARD;
  }

  getMaxZoom(): number {
    return 19;
  }

  getUrlTemplate(mapType?: MapType): string {
    return OpenStreetMapsTileProvider.URL_OSM_STANDARD;
  }

  getUrl(x, y, zoom, mapType?: MapType): string {
    return OpenStreetMapsTileProvider.URL_OSM_STANDARD
      .replace('{z}', zoom)
      .replace('{x}', x)
      .replace('{y}', y);
  }

}
